import { render, staticRenderFns } from "./managerightclick.vue?vue&type=template&id=46b09eb2&"
import script from "./managerightclick.vue?vue&type=script&lang=js&"
export * from "./managerightclick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports